export interface ISettings {
    defaultFilters: string[];
    defaultEventCategories: string[];
    markerIsLiveHours: number;
    errorEmails: string[];
}

export enum AdminTools {
    Admin = 1,
    Filter = 2,
    Settings = 3
}
